import { useEffect } from "react";
import { ClassDetailsViewModel } from "../../../viewmodels/setup/classes/ClassDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter } from "../../../shared/utility";

import EmptyModal from "../../../components/modals/EmptyModal";
import TableLoadingSkeleton from "../../../components/shared/TableLoadingSkeleton";

import SimpleNotification from "../../../components/SimpleNotification";
import AuditActionLink from "../../../components/audit/AuditActionLink";

import { useParams } from "react-router-dom";
import SelectMenu from "../../../components/controls/SelectMenu";
import { useForm } from "../../../components/forms/useForm";

import { Checkbox } from "primereact/checkbox";

const initialFValues = {
  id: null,
  name: "",
  specSheetTests: [],
  specSheetAllergens: [],
};

function ClassDetails(props) {
  const { logout } = props;

  const { id } = useParams();

  const {
    getClass,
    loading,
    classe,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    getSpecSheetTestsForDropdown,
    getAllergens,
    updateClass,
    allergenOptions,
    specSheetTestOptions,
  } = ClassDetailsViewModel(logout, id);

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false
  );

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("name" in fieldValues) {
      temp.name = null;
      if (fieldValues.name.value === -1) {
        temp.name = "This field is required.";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      updateClass(values);
    }
  };

  useEffect(() => {
    getSpecSheetTestsForDropdown();
    getAllergens();
    getClass();
  }, []);

  useEffect(() => {
    if (classe) {
      var testsSelected = [];
      if (classe) {
        if (classe.spec_sheet_tests) {
          const assignedTestIds = classe.spec_sheet_tests.map((t) => t.id);

          testsSelected = specSheetTestOptions.filter((el) =>
            assignedTestIds.includes(el.value)
          );

          if (typeof testsSelected === "undefined") {
            testsSelected = { value: null };
          }
        }
      }

      setValues({
        id: classe.id,
        name: classe.name,
        specSheetTests: testsSelected,
        specSheetAllergens: classe.spec_sheet_allergens,
      });
    }
  }, [specSheetTestOptions, classe]);

  const updateAllergenPivot = (allergenId, field, checked) => {
    const exists = values.specSheetAllergens.find((a) => a.id === allergenId);

    if (field === "used") {
      if (checked && !exists) {
        // Add new allergen when "Used" is checked
        const newAllergen = allergenOptions.find((a) => a.value === allergenId);
        if (!newAllergen) return;

        setValues((prev) => ({
          ...prev,
          specSheetAllergens: [
            ...prev.specSheetAllergens,
            {
              id: allergenId,
              name: newAllergen.label,
              pivot: {
                classes_id: values.id,
                allergens_id: allergenId,
                in_product: 0,
                in_same_plant: 0,
              },
            },
          ],
        }));
      }

      if (!checked && exists) {
        // Remove allergen when "Used" is unchecked
        setValues((prev) => ({
          ...prev,
          specSheetAllergens: prev.specSheetAllergens.filter(
            (a) => a.id !== allergenId
          ),
        }));
      }

      return; // Don't continue into other fields if we're handling "used"
    }

    // Update pivot fields (in_product or in_same_plant)
    if (exists) {
      setValues((prev) => ({
        ...prev,
        specSheetAllergens: prev.specSheetAllergens.map((a) =>
          a.id === allergenId
            ? {
                ...a,
                pivot: {
                  ...a.pivot,
                  [field]: checked ? 1 : 0,
                },
              }
            : a
        ),
      }));
    }
  };

  const isUsed = (id) => values.specSheetAllergens.some((a) => a.id === id);

  const getPivot = (id, field) =>
    values.specSheetAllergens.find((a) => a.id === id)?.pivot?.[field] === 1;

  return (
    <div>
      <SimpleNotification
        setShow={setShowSimpleNotification}
        showSimpleNotification={showSimpleNotification}
      />
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:items-center space-y-4">
          <div className="sm:flex sm:items-center sm:justify-between sm:flex-auto">
            <h1 className="text-2xl font-semibold leading-6 text-gray-900">
              {values.name}
            </h1>
            {values.id != null && (
              <AuditActionLink
                slug="class"
                id={values.id}
                name={values.name}
              />
            )}
          </div>

          <div className="px-4 py-2 sm:px-4 card-custom">
            <div className="sm:flex sm:items-center">
              <h1 className="text-base font-semibold leading-6 text-gray-900 flex-grow">
                Spec Sheet Tests
              </h1>
            </div>

            <SelectMenu
              parentClass="col-span-2"
              handleInputChange={handleInputChange}
              name="specSheetTests"
              options={specSheetTestOptions}
              value={values.specSheetTests}
              title={"Tests"}
              error={errors.specSheetTests}
              showLabel={true}
              isMulti={true}
            />
          </div>

          <div className="px-4 py-2 sm:px-4 card-custom">
            <div className="sm:flex sm:items-center">
              <h1 className="text-base font-semibold leading-6 text-gray-900 flex-grow">
                Spec Sheet Allergens
              </h1>
            </div>
            <div className="inline-block min-w-full py-2 align-middle">
              {loading ? (
                <TableLoadingSkeleton rows={5} columns={4} />
              ) : (
                <div className="overflow-hidden">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-white">
                      <tr>
                        <th
                          scope="col"
                          className="py-3 pr-3 text-left text-sm font-semibold text-gray-900"
                        >
                          Name
                        </th>
                        <th
                          scope="col"
                          className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                        >
                          Show in specsheet
                        </th>
                        <th
                          scope="col"
                          className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                        >
                          In product
                        </th>
                        <th
                          scope="col"
                          className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                        >
                          In same plant
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {allergenOptions.length === 0 ? (
                        <tr>
                          <td className="whitespace-nowrap py-1.5 pr-3 text-sm font-medium text-gray-500">
                            No allergens, please add one
                          </td>
                        </tr>
                      ) : (
                        allergenOptions.map((allergen, index) => (
                          <tr key={allergen.value}>
                            <td className="whitespace-nowrap py-1.5 pr-3 text-sm font-medium text-gray-500">
                              {allergen.label}
                            </td>
                            <td className="relative whitespace-nowrap py-1.5 pl-3 pr-4 text-center text-sm font-medium sm:pr-6">
                              <Checkbox
                                onChange={(e) =>
                                  updateAllergenPivot(
                                    allergen.value,
                                    "used",
                                    e.target.checked
                                  )
                                }
                                checked={isUsed(allergen.value)}
                              ></Checkbox>
                            </td>
                            <td className="relative whitespace-nowrap py-1.5 pl-3 pr-4 text-center text-sm font-medium sm:pr-6">
                              <Checkbox
                                disabled={!isUsed(allergen.value)}
                                checked={getPivot(allergen.value, "in_product")}
                                onChange={(e) =>
                                  updateAllergenPivot(
                                    allergen.value,
                                    "in_product",
                                    e.target.checked
                                  )
                                }
                              ></Checkbox>
                            </td>
                            <td className="relative whitespace-nowrap py-1.5 pl-3 pr-4 text-center text-sm font-medium sm:pr-6">
                              <Checkbox
                                disabled={!isUsed(allergen.value)}
                                checked={getPivot(
                                  allergen.value,
                                  "in_same_plant"
                                )}
                                onChange={(e) =>
                                  updateAllergenPivot(
                                    allergen.value,
                                    "in_same_plant",
                                    e.target.checked
                                  )
                                }
                              ></Checkbox>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

          <button
            type="submit"
            className="inline-flex justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={handleSubmit}
          >
            Save
          </button>

        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ClassDetails)
);
